"use strict";
/**
 * AngularJS overlay component controller.
 *
 * @packageDocumentation
 * @module Overlay
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
//#region Util Imports
var lodash_es_1 = require("lodash-es");
var base_1 = require("../../../../components/base");
var IMROverlayController = /** @class */ (function (_super) {
    tslib_1.__extends(IMROverlayController, _super);
    //#endregion
    //#region Ctor
    function IMROverlayController($element) {
        var _this = _super.call(this) || this;
        _this.$element = $element;
        //#region Members
        _this.isLoading = false;
        _this.hasContent = false;
        //#endregion
        //#region Bottom Toolbar
        _this.bottomToolbarOptions = null;
        return _this;
    }
    //#endregion
    //#region Lifecycle
    IMROverlayController.prototype.initialize = function (options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.hasContent = this.$element.find('.imr-overlay-content-content > ng-transclude').children().length > 0;
                this.initializeBottomToolbar();
                return [2 /*return*/];
            });
        });
    };
    //#endregion
    //#region IIMRPopup Implementation
    IMROverlayController.prototype.hideLoading = function () {
        this.toggleLoading(false);
    };
    IMROverlayController.prototype.showLoading = function () {
        this.toggleLoading(true);
    };
    IMROverlayController.prototype.toggleLoading = function (isLoading) {
        this.isLoading = isLoading;
    };
    IMROverlayController.prototype.initializeBottomToolbar = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.prepareBottomToolbarOptions();
                        return [4 /*yield*/, this.waitForBottomToolbarInitialized()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IMROverlayController.prototype.prepareBottomToolbarOptions = function () {
        var _a;
        this.bottomToolbarOptions = (_a = lodash_es_1.cloneDeep(this.options.bottomToolbarOptions)) !== null && _a !== void 0 ? _a : null;
    };
    IMROverlayController.prototype.waitForBottomToolbarInitialized = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.bottomToolbarOptions != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, _super.prototype.waitForOnInitialized.call(this, this.bottomToolbarOptions)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return IMROverlayController;
}(base_1.IMRBaseComponentController));
exports.IMROverlayController = IMROverlayController;
//# sourceMappingURL=overlay-content.controller.js.map